/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — user-area route; bootstraps an anonymous session,
 *              starts the home-data load, and opens the default tab
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     none (returns undefined)
 *   key:       beforeModel (session.setAnonymous(true) + bootstrapSession),
 *              setupController (controller.checkHomeTask.perform(), resets
 *              showMenu, calls controller.applyTab(controller.tab)),
 *              resetController (cancels checkHomeTask)
 *   uses:      services: session, controllerFor('application')
 *   siblings:  controllers/user.js, templates/user.hbs
 *   tests:     wave5-coverage-test.js
 *   gotchas:   entering the route with the `tab` query param already at its
 *              default value never fires the controller's tab setter (no
 *              change to observe), so setupController explicitly calls
 *              `controller.applyTab(controller.tab)` to open the initial
 *              section.
 *
 * Route for the public user area: same anonymous-session bootstrap as
 * routes/sciclub.js, then hands off to UserController's checkHomeTask and
 * tab-section logic.
 */
import Route from '@ember/routing/route';
import { set } from '@ember/object';
import { inject as iService } from '@ember/service';

export default class UserRoute extends Route {
  @iService session;

  model() {}

  async beforeModel(transition) {
    await super.beforeModel(transition);
    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.checkHomeTask.perform();
    set(controller, 'showMenu', null);
    // Entering the route with the param already at its default never fires the
    // controller's `tab` setter, so the initial section is opened here.
    controller.applyTab(controller.tab);
  }

  resetController(controller) {
    controller.checkHomeTask.cancelAll();
  }
}
